module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABQklEQVQ4T7WUO07EMBCGZ9LkTqk8bvYCSIhHCQUUPIoFUSOtxLLiUbAFPSxC4gq2j8IJaBBCSpEfeUVQII5jUEjp2J/HM98M08AfD8yjL6AxBlmWLZRS6ymXOOeuAewR0ZOIrNRnmsA5Ee0w852IbMag1torItonooeyLLdGo9FbC+gXnHM3VVXtxqDW2ksiOvAwEVn7eXErhzFoDQOw0FoHUxMsSghqjLlg5sMYzEfbWWUPBeCfPwHwQkQzZr5XSm3E8hvVxjl3AmDyCZiJyLjPgD7gGMB0+RTmc6XU0Z+BtRrMPAXwCuA0RalghCE1UpQKFiXmWQr0W4QpavRBm6239CxFjSY0z/PtoijeW61nrUVXO4Uq65ybA/C9/6iUWg0NhzOt9XGfFs3/xhjv6LPW+jY4HH4D69r7fwN2iOg84wO5QcAVrSKu4QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x.png
// module id = VgmL
// module chunks = 1